import Title from './Title';
import './Title.scss';

export default Title; 